import { render, staticRenderFns } from "./ReceptionTableComponent.vue?vue&type=template&id=767a67ce"
import script from "./ReceptionTableComponent.vue?vue&type=script&lang=js"
export * from "./ReceptionTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports